import { render } from "./BagPitTypeTable.vue?vue&type=template&id=9377e388&scoped=true"
import script from "./BagPitTypeTable.vue?vue&type=script&lang=js"
export * from "./BagPitTypeTable.vue?vue&type=script&lang=js"

import "./BagPitTypeTable.vue?vue&type=style&index=0&id=9377e388&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9377e388"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
